import { Option } from '@inrev/core';
import { usStateOrTerritorySchema } from '../enums.mjs';

const STATE_NAME_BY_CODE = {
    AL: "Alabama",
    AK: "Alaska",
    AZ: "Arizona",
    AR: "Arkansas",
    CA: "California",
    CO: "Colorado",
    CT: "Connecticut",
    DE: "Delaware",
    DC: "District of Columbia",
    FL: "Florida",
    GA: "Georgia",
    HI: "Hawaii",
    ID: "Idaho",
    IL: "Illinois",
    IN: "Indiana",
    IA: "Iowa",
    KS: "Kansas",
    KY: "Kentucky",
    LA: "Louisiana",
    ME: "Maine",
    MD: "Maryland",
    MA: "Massachusetts",
    MI: "Michigan",
    MN: "Minnesota",
    MS: "Mississippi",
    MO: "Missouri",
    MT: "Montana",
    NE: "Nebraska",
    NV: "Nevada",
    NH: "New Hampshire",
    NJ: "New Jersey",
    NM: "New Mexico",
    NY: "New York",
    NC: "North Carolina",
    ND: "North Dakota",
    OH: "Ohio",
    OK: "Oklahoma",
    OR: "Oregon",
    PA: "Pennsylvania",
    RI: "Rhode Island",
    SC: "South Carolina",
    SD: "South Dakota",
    TN: "Tennessee",
    TX: "Texas",
    UT: "Utah",
    VT: "Vermont",
    VA: "Virginia",
    WA: "Washington",
    WV: "West Virginia",
    WI: "Wisconsin",
    WY: "Wyoming",
};
const DC_ALIASES = ["Washington DC", "Washington, D.C."];
const toLookupKey = (value) => value
    .toLowerCase()
    .replace(/[^a-z\s]/g, "")
    .replace(/\s+/g, " ")
    .trim();
const CODE_BY_NAME = new Map([
    ...Object.entries(STATE_NAME_BY_CODE).map(([code, name]) => [toLookupKey(name), code]),
    ...DC_ALIASES.map((alias) => [toLookupKey(alias), "DC"]),
]);
function normalizeUsStateOrTerritory(value) {
    if (Option.isNone(value))
        return null;
    const trimmed = value.trim();
    if (trimmed === "")
        return null;
    const asCode = usStateOrTerritorySchema.safeParse(trimmed.toUpperCase());
    if (asCode.success)
        return asCode.data;
    return CODE_BY_NAME.get(toLookupKey(trimmed)) ?? null;
}

export { normalizeUsStateOrTerritory };
